import React, { FC } from 'react';
import { Editor } from '@tiptap/react';
import { EditorState } from '@tiptap/pm/state';
import { FloatingMenu } from '@tiptap/react/menus';

import {
  FaHeading, FaListUl, FaListOl, FaTable,
} from 'react-icons/fa';

const HeadingIcon = FaHeading as React.ComponentType;
const BulletListIcon = FaListUl as React.ComponentType;
const OrderedListIcon = FaListOl as React.ComponentType;
const TableIcon = FaTable as React.ComponentType;

interface FloatingMenuProps {
  editor: Editor | null;
}

interface ShouldShowProps {
  editor: Editor;
  state: EditorState;
}

const FloatingMenuComponent: FC<FloatingMenuProps> = ({ editor }) => {
  if (!editor) {
    return null;
  }

  return (
    <FloatingMenu
      className="menu-floating"
      editor={editor}
      options={{
        placement: 'left-start',
        // you can add other Floating UI options here if you want
      }}
      shouldShow={({ state }: ShouldShowProps) => {
        const { $from } = state.selection;
        const parent = $from.parent;
        return parent.isTextblock && parent.content.size === 0;
      }}
    >
      <button
        type="button"
        onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()}
        className={`menu-button ${editor.isActive('heading', { level: 1 }) ? 'is-active' : ''}`}
        title="Heading 1"
      >
        <HeadingIcon /> 1
      </button>

      <button
        type="button"
        onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
        className={`menu-button ${editor.isActive('heading', { level: 2 }) ? 'is-active' : ''}`}
        title="Heading 2"
      >
        <HeadingIcon /> 2
      </button>

      <button
        type="button"
        onClick={() => editor.chain().focus().toggleBulletList().run()}
        className={`menu-button ${editor.isActive('bulletList') ? 'is-active' : ''}`}
        title="Bullet List"
      >
        <BulletListIcon /> 
      </button>

      <button
        type="button"
        onClick={() => editor.chain().focus().toggleOrderedList().run()}
        className={`menu-button ${editor.isActive('orderedList') ? 'is-active' : ''}`}
        title="Ordered List"
      >
        <OrderedListIcon /> 
      </button>

      <button
        type="button"
        onClick={() =>
          editor.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: true }).run()
        }
        className="menu-button"
        title="Insert Table"
      >
        <TableIcon />
      </button>

    </FloatingMenu>
  );
};

export default FloatingMenuComponent;
